export default __webpack_public_path__ + "static/media/error-outline-icon--orange.cb9240c3.svg";